import iconPinMap from '@/assets/images/icon-location-pin-map.png';
import iconPinMapKickbaord from '@/assets/images/icon-location-pin-map-kickboard.png';
import { isPathEk } from '@/utils/routes';
import { cn } from '@/utils/utils';
import { useLocation } from 'react-router-dom';

interface IconLocationPinMapProps {
    readonly alt?: string,
    readonly className?: string
}

export default function IconLocationPinMap({ alt, className }: IconLocationPinMapProps) {
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    return (
        <img
            src={isEk ? iconPinMapKickbaord : iconPinMap}
            alt={alt ?? ''}
            className={cn('h-[62px]', className)}
        />
    );
}
